import dayjs from 'dayjs';
import { IPatientDemographics } from '@zero-dash/types';
import { boolToStr } from './bools';

interface IAge {
  age: number;
  units: 'Months' | 'Years';
}

export function getAgeFromDob(
  demographics: IPatientDemographics,
  inYears = false,
): IAge {
  const dob = dayjs(demographics.dateOfBirth.replaceAll('-', ' '));
  const { dateOfDeath } = demographics;

  if (!inYears && dayjs(dateOfDeath).diff(dob, 'month') < 23) {
    return {
      age: dayjs(dateOfDeath).diff(dob, 'month'),
      units: 'Months',
    };
  }
  return {
    age: dayjs(dateOfDeath || undefined).diff(dob, 'year'),
    units: 'Years',
  };
}

/**
 * Determines whether the patient is an adult (>= 18 years) from date of birth
 * via Clinical One demographics (current age, or age at death if deceased).
 */
export function getIsAdultPatient(
  demographics?: IPatientDemographics | null,
): boolean {
  if (!demographics?.dateOfBirth) {
    return false;
  }
  return getAgeFromDob(demographics, true).age >= 18;
}

export function formatPaediatricDose(
  hasPaediatricDose: boolean | null | undefined,
  isAdultPatient: boolean,
): string {
  if (isAdultPatient) {
    return 'N/A';
  }
  return boolToStr(hasPaediatricDose) || '-';
}
